import FiltersSection from './filtersSection';

export default FiltersSection;
